module.exports = __webpack_public_path__ + "media/images/emblems/Mollens-coat_of_arms-b5944222476199f1d41f7c5bdfd4d030.svg";